"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSimulation = createSimulation;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactIntl = require("react-intl");

var _d3Drag = require("d3-drag");

var _d3Selection = require("d3-selection");

var _d3Force = require("d3-force");

var _d3Scale = require("d3-scale");

var _geometryUtils = require("../../util/geometryUtils");

var _d3Utils = require("../../util/d3Utils");

var _animationUtils = require("../../util/animationUtils");

var _Tooltip = _interopRequireDefault(require("./Tooltip"));

var _EdgeLegend = _interopRequireDefault(require("./EdgeLegend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EdgeGroup = _styledComponents.default.g.withConfig({
  displayName: "GroupsNetworkGraph__EdgeGroup",
  componentId: "sc-1jjor52-0"
})(["cursor:", ";&:hover > .arrow{", ";}&:hover > g > .link{", ";}"], function (_ref) {
  var isClickable = _ref.isClickable;
  return isClickable ? 'pointer' : 'default';
}, function (_ref2) {
  var isClickable = _ref2.isClickable;
  return isClickable ? 'fill: lightgray;' : '';
}, function (_ref3) {
  var isClickable = _ref3.isClickable;
  return isClickable ? 'stroke: lightgray;' : '';
});

var NODE_RADIUS_RANGE = {
  small: {
    minRadius: 1.5,
    maxRadius: 15
  },
  regular: {
    minRadius: 3,
    maxRadius: 30
  }
};
var LINK_SIZE_FACTOR = {
  small: {
    minWidth: 1.5,
    factor: 6
  },
  regular: {
    minWidth: 3,
    factor: 12
  }
};
var ARROW_SIZE_RANGE = {
  small: [2, 6],
  regular: [4, 10]
};
var gMinLinkWidth = 3;

function prepareLinkWidthScale(minLinkValue, maxLinkValue, minWidth, linkFactor) {
  return function (value) {
    if (value - minLinkValue !== 0 && maxLinkValue - minLinkValue !== 0) {
      return gMinLinkWidth + linkFactor * (value - minLinkValue) / (maxLinkValue - minLinkValue);
    } else {
      return gMinLinkWidth;
    }
  };
}

function prepareArrowWidthScale(minLinkValue, maxLinkValue, arrowSizeRange) {
  return (0, _d3Scale.scaleLinear)().domain([minLinkValue, maxLinkValue]).range(arrowSizeRange);
} // Compute min/max values across entire data set


function maxima(nodes, edges) {
  var nodeValues = nodes.map(function (n) {
    return n.value && JSON.parse(n.value);
  });
  var minNodeValue = nodeValues.reduce(function (min, v) {
    return v < min ? v : min;
  }, Number.MAX_SAFE_INTEGER);
  var maxNodeValue = nodeValues.reduce(function (max, v) {
    return v > max ? v : max;
  }, 0);
  var linkValues = edges.map(function (e) {
    return e.value && JSON.parse(e.value);
  });
  var minLinkValue = linkValues.reduce(function (min, v) {
    return v < min ? v : min;
  }, Number.MAX_SAFE_INTEGER);
  var maxLinkValue = linkValues.reduce(function (max, v) {
    return v > max ? v : max;
  }, 0);
  return {
    minNodeValue: minNodeValue,
    maxNodeValue: maxNodeValue,
    minLinkValue: minLinkValue,
    maxLinkValue: maxLinkValue
  };
}

function determineLinkColor(edgeColors, tertiary, inverted, theme) {
  if (edgeColors) {
    var fallback = determineLinkColor(null, tertiary, inverted, theme)();
    return edgeColors.unknown(fallback);
  }

  if (tertiary) {
    return function () {
      return theme.one[1];
    };
  }

  if (inverted) return function () {
    return theme.inverted.one[0];
  };
  return function () {
    return theme.one[0];
  };
}

function determineNodeFill(_ref4) {
  var colors = _ref4.colors,
      secondary = _ref4.secondary,
      tertiary = _ref4.tertiary,
      inverted = _ref4.inverted,
      theme = _ref4.theme;
  if (colors) return colors;

  if (secondary) {
    return function () {
      return 'transparent';
    };
  }

  if (tertiary) {
    return function () {
      return 'url(#diagonalNodeHatch)';
    };
  }

  if (inverted) return function () {
    return theme.inverted.one[0];
  };
  return function () {
    return theme.one[0];
  };
}

function determineNodeStroke(_ref5) {
  var colors = _ref5.colors,
      secondary = _ref5.secondary,
      tertiary = _ref5.tertiary,
      inverted = _ref5.inverted,
      theme = _ref5.theme;
  if (colors) return colors;

  if (secondary) {
    return inverted ? function () {
      return theme.inverted.one[0];
    } : function () {
      return theme.one[0];
    };
  }

  if (tertiary) {
    return function () {
      return theme.one[1];
    };
  }

  return function () {
    return 'transparent';
  };
} // Render path of a given link from a source node to a target node


function linkPath(sourceNode, targetNode, nodeRadiusScale, hasCurvedEdges, normalizedValue, isUnidirectional) {
  // Deal with edges pointing at self
  var path;
  var offsetOffset = normalizedValue * 1.1;
  var sourceOffsetX = 0;
  var sourceOffsetY = 0;
  var targetOffsetX = 0;
  var targetOffsetY = 0;
  var sourceRadius = nodeRadiusScale(sourceNode.value);
  var targetRadius = nodeRadiusScale(targetNode.value);

  if (sourceNode.id === targetNode.id) {
    // Edges pointing at self
    var radius = sourceRadius;
    var degrees57 = 1;
    sourceOffsetX = -radius;
    sourceOffsetY = 0;
    targetOffsetX = -(radius * Math.cos(degrees57));
    targetOffsetY = -(radius * Math.sin(degrees57));
    var sourceControlX = -(radius * 2.5);
    var sourceControlY = 0;
    var targetControlX = -(radius * 2.5 * Math.cos(degrees57));
    var targetControlY = -(radius * 2.5 * Math.sin(degrees57));
    path = "M".concat(sourceNode.x + sourceOffsetX, ",").concat(sourceNode.y + sourceOffsetY, "C").concat(sourceNode.x + sourceControlX, " ").concat(sourceNode.y + sourceControlY, ",").concat(targetNode.x + targetControlX, " ").concat(targetNode.y + targetControlY, ",").concat(targetNode.x + targetOffsetX, ",").concat(targetNode.y + targetOffsetY);
  } else {
    // Edges between nodes
    // Total difference in x and y from source to target
    var diffX = targetNode.x - sourceNode.x;
    var diffY = targetNode.y - sourceNode.y; // Length of path from center of source node to center of target node

    var pathLength = Math.sqrt(diffX * diffX + diffY * diffY); // x and y distances from center to outside edge of target node

    if (pathLength > 0) {
      var sourceGeneralOffset = isUnidirectional ? offsetOffset : 0;
      var targetGeneralOffset = offsetOffset;
      sourceOffsetX = diffX * (sourceRadius + sourceGeneralOffset) / pathLength;
      sourceOffsetY = diffY * (sourceRadius + sourceGeneralOffset) / pathLength;
      targetOffsetX = diffX * (targetRadius + targetGeneralOffset) / pathLength;
      targetOffsetY = diffY * (targetRadius + targetGeneralOffset) / pathLength;
    }

    var sourceX = sourceNode.x + sourceOffsetX;
    var sourceY = sourceNode.y + sourceOffsetY;
    var targetX = targetNode.x - targetOffsetX;
    var targetY = targetNode.y - targetOffsetY;

    if (hasCurvedEdges) {
      // Curved edges
      path = "M".concat(sourceX, ",").concat(sourceY, "A").concat(pathLength, ",").concat(pathLength, " 0 0,1 ").concat(targetX, ",").concat(targetY);
    } else {
      // Direct edges
      path = "M".concat(sourceX, ",").concat(sourceY, " L").concat(targetX, ",").concat(targetY);
    }
  }

  return path;
} // Bounding box force (Constrains graph within box)


function boxForce(nodes, height, width, nodeRadiusScale) {
  var forceFunction = {};

  var setForceFunction = function setForceFunction() {
    forceFunction = function forceFunction() {
      for (var i = 0, n = nodes.length; i < n; ++i) {
        var curr_node = nodes[i];
        var padding = 20;
        var radius = nodeRadiusScale(curr_node.value) + padding;
        var buffer = radius + padding;
        curr_node.x = Math.max(buffer, Math.min(width - buffer, curr_node.x));
        curr_node.y = Math.max(buffer, Math.min(height - buffer, curr_node.y));
      }
    };
  };

  setForceFunction();

  forceFunction.height = function (value) {
    if (value) {
      height = value;
      setForceFunction();
    }

    return height;
  };

  forceFunction.width = function (value) {
    if (value) {
      width = value;
      setForceFunction();
    }

    return width;
  };

  return forceFunction;
} // Arrow heads at end of links (edges)


function arrowHeads(nodeSource, nodeTarget, edgeValue, arrowWidthScale, nodeRadiusScale) {
  var normalizedValue = arrowWidthScale(edgeValue);
  var s = normalizedValue * 1.2;
  var sourceRadius = nodeRadiusScale(nodeSource.value);
  var targetRadius = nodeRadiusScale(nodeTarget.value);
  var offsetOffset = normalizedValue * 1.0;
  var diffX = nodeTarget.x - nodeSource.x;
  var diffY = nodeTarget.y - nodeSource.y;
  var pathLength = Math.sqrt(diffX * diffX + diffY * diffY);
  var angle = Math.atan2(nodeTarget.y - nodeSource.y, nodeTarget.x - nodeSource.x) * 180 / Math.PI + 90;
  var sourceOffsetX = diffX * (sourceRadius + offsetOffset) / pathLength;
  var sourceOffsetY = diffY * (sourceRadius + offsetOffset) / pathLength;
  var targetOffsetX = diffX * (targetRadius + offsetOffset) / pathLength;
  var targetOffsetY = diffY * (targetRadius + offsetOffset) / pathLength;
  var x1 = nodeSource.x + sourceOffsetX;
  var y1 = nodeSource.y + sourceOffsetY;
  var x2 = nodeTarget.x - targetOffsetX;
  var y2 = nodeTarget.y - targetOffsetY;
  return {
    source: {
      transform: "translate(".concat(x1 - s, ", ").concat(y1 - s, ") rotate(").concat(angle + 180, ", ").concat(s, ", ").concat(s, ")"),
      d: "M 0,".concat(s * 1.7, " H ").concat(s * 2, " L ").concat(s, ",0 Z")
    },
    target: {
      transform: "translate(".concat(x2 - s, ", ").concat(y2 - s, ") rotate(").concat(angle, ", ").concat(s, ", ").concat(s, ")"),
      d: "M 0,".concat(s * 1.7, " H ").concat(s * 2, " L ").concat(s, ",0 Z")
    }
  };
} // Drag-and-drop nodes


function assignDragHandlers(elm, simulation, node, onDragEnd) {
  // Prepare d3 drag event handlers (https://bl.ocks.org/mbostock/4062045)
  var dragFunc = (0, _d3Drag.drag)().on('start', function (node) {
    if (!_d3Selection.event.active) simulation.alphaTarget(0.3).restart();
    node.fx = node.x;
    node.fy = node.y;
  }).on('drag', function (node) {
    node.fx = _d3Selection.event.x;
    node.fy = _d3Selection.event.y;
  }).on('end', function (node) {
    if (!_d3Selection.event.active) simulation.alphaTarget(0).stop();
    node.fx = null;
    node.fy = null;
    var coordinates = {};
    simulation.nodes().forEach(function (node) {
      return coordinates[node.id] = {
        x: node.x,
        y: node.y
      };
    });
    onDragEnd(coordinates);
  }); // Use d3 selection to add handlers to element

  return elm && dragFunc((0, _d3Selection.select)(elm).data([node]));
}

function createSimulation(nodes, edges, width, height, size, linkForceDistance, nodeCollideRadius) {
  var _maxima = maxima(nodes, edges),
      minNodeValue = _maxima.minNodeValue,
      maxNodeValue = _maxima.maxNodeValue;

  var _NODE_RADIUS_RANGE$si = NODE_RADIUS_RANGE[size],
      minRadius = _NODE_RADIUS_RANGE$si.minRadius,
      maxRadius = _NODE_RADIUS_RANGE$si.maxRadius;
  var nodeRadiusScale = (0, _geometryUtils.areaRelativeRadiusScale)(minNodeValue, maxNodeValue, minRadius, maxRadius); // Initialize forces

  var simulation = (0, _d3Force.forceSimulation)(nodes);
  var linkForce = (0, _d3Force.forceLink)(edges).id(function (d) {
    return d.id;
  }).distance(linkForceDistance);
  var nodeCollide = (0, _d3Force.forceCollide)(nodeCollideRadius); // Initialize force simulation

  simulation.force('charge_force', (0, _d3Force.forceManyBody)()).force('center_force', (0, _d3Force.forceCenter)(width / 2, height / 2)).force('box_force', boxForce(nodes, height, width, nodeRadiusScale)).force('links', linkForce).force('collide', nodeCollide); //.on('end', this.handleSimulationEnd)

  return simulation;
}

var GroupsNetworkGraph = /*#__PURE__*/function (_Component) {
  _inherits(GroupsNetworkGraph, _Component);

  var _super = _createSuper(GroupsNetworkGraph);

  function GroupsNetworkGraph(props) {
    var _this;

    _classCallCheck(this, GroupsNetworkGraph);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleEdgeClick", function (edge) {
      var onEdgeClick = _this.props.onEdgeClick;

      if (onEdgeClick) {
        onEdgeClick(edge.source.id, edge.target.id, edge.isUniDirectional);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleNodeClick", function (node) {
      var onNodeClick = _this.props.onNodeClick;

      if (onNodeClick) {
        onNodeClick(node.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSimulationEnd", function () {
      var nodes = _this.simulation.nodes();

      nodes = JSON.parse(JSON.stringify(nodes));

      _this.props.onSimulationEnd(nodes);

      _this.setState({
        simulationEnded: true
      });
    });

    var hasCoordinates = props.nodeCoordinates && Object.keys(props.nodeCoordinates).length > 0;
    var simulationEnded = false; // Clone data (this is needed because d3-force is not pure)

    var _nodes = JSON.parse(JSON.stringify(props.data.nodes));

    var edges = JSON.parse(JSON.stringify(props.data.edges)); // Include initial node coordinates, if provided

    if (hasCoordinates) {
      _nodes = _nodes.map(function (node) {
        return _objectSpread(_objectSpread({}, node), props.nodeCoordinates[node.id]);
      });
    } // Prepare scales


    var _maxima2 = maxima(_nodes, edges),
        minNodeValue = _maxima2.minNodeValue,
        maxNodeValue = _maxima2.maxNodeValue,
        minLinkValue = _maxima2.minLinkValue,
        maxLinkValue = _maxima2.maxLinkValue;

    var _NODE_RADIUS_RANGE$pr = NODE_RADIUS_RANGE[props.size],
        minRadius = _NODE_RADIUS_RANGE$pr.minRadius,
        maxRadius = _NODE_RADIUS_RANGE$pr.maxRadius;
    var nodeRadiusScale = (0, _geometryUtils.areaRelativeRadiusScale)(minNodeValue, maxNodeValue, minRadius, maxRadius);
    var _LINK_SIZE_FACTOR$pro = LINK_SIZE_FACTOR[props.size],
        minWidth = _LINK_SIZE_FACTOR$pro.minWidth,
        factor = _LINK_SIZE_FACTOR$pro.factor;
    var linkWidthScale = prepareLinkWidthScale(minLinkValue, maxLinkValue, minWidth, factor);
    var arrowWidthRange = ARROW_SIZE_RANGE[props.size];
    var arrowWidthScale = prepareArrowWidthScale(minLinkValue, maxLinkValue, arrowWidthRange); // Initialize simulation

    var width = props.width,
        height = props.height,
        size = props.size,
        linkForceDistance = props.linkForceDistance,
        nodeCollideRadius = props.nodeCollideRadius;
    _this.simulation = createSimulation(_nodes, edges, width, height, size, linkForceDistance, nodeCollideRadius);

    _this.simulation.on('end', _this.handleSimulationEnd); //this.simulation = this.createSimulation(nodes, edges, nodeRadiusScale)
    // If coordinates provided, don't run simulation until triggered
    // (We still initialize it, in case user starts dragging, in which case it will get triggered)


    if (hasCoordinates) {
      _this.simulation.stop();

      simulationEnded = true; // Since we won't run simulation we can show graph on IE right away
    } // Prepare colors


    var ids = _nodes.map(function (n) {
      return n.id;
    });

    var _makeGroupColorScales = (0, _d3Utils.makeGroupColorScales)(props.theme, ids),
        primaryColors = _makeGroupColorScales.primaryColors; // Store references to everything in component state


    _this.state = {
      nodes: _this.simulation.nodes(),
      hoveredEdge: null,
      hoveredNode: null,
      simulationEnded: simulationEnded,
      edges: edges,
      nodeRadiusScale: nodeRadiusScale,
      linkWidthScale: linkWidthScale,
      arrowWidthScale: arrowWidthScale,
      primaryColors: primaryColors
    };

    _this.bindSimulationTick();

    return _this;
  }

  _createClass(GroupsNetworkGraph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSimulation(this.props);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.updateSimulation(nextProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindSimulationTick();
    }
  }, {
    key: "onSimulationTick",
    value: function onSimulationTick() {
      this.frame = (0, _animationUtils.requestAnimationFrame)(this.updatePositions.bind(this));
    }
  }, {
    key: "bindSimulationTick",
    value: function bindSimulationTick() {
      this.simulation.on('tick', this.updateSimulation.bind(this));
    }
  }, {
    key: "unbindSimulationTick",
    value: function unbindSimulationTick() {
      this.simulation.on('tick', null);
      this.simulation.stop();
      this.frame = this.frame && (0, _animationUtils.cancelAnimationFrame)(this.frame);
    }
  }, {
    key: "updateSimulation",
    value: function updateSimulation() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var width = props.width,
          height = props.height,
          linkForceDistance = props.linkForceDistance,
          nodeCollideRadius = props.nodeCollideRadius;
      var simulation = this.simulation; // Update center force, if needed

      var centerX = width / 2;
      var centerY = height / 2;

      if (simulation.force('center_force').x() !== centerX) {
        simulation.shouldRun = true;
        simulation.force('center_force').x(centerX);
      }

      if (simulation.force('center_force').y() !== centerY) {
        simulation.shouldRun = true;
        simulation.force('center_force').y(centerY);
      } // Update box force


      var boxForce = simulation.force('box_force');

      if (boxForce.height() !== height) {
        simulation.shouldRun = true;
        boxForce.height(height);
      }

      if (boxForce.width() !== width) {
        simulation.shouldRun = true;
        boxForce.width(width);
      } // Update link force


      if (simulation.force('links').distance()() !== linkForceDistance) {
        simulation.shouldRun = true;
        simulation.force('links').distance(linkForceDistance);
      } // Update collision force


      if (simulation.force('collide').radius()() !== nodeCollideRadius) {
        simulation.shouldRun = true;
        simulation.force('collide').radius(nodeCollideRadius);
      }

      if (simulation.shouldRun) {
        simulation.shouldRun = null;
        simulation.alpha(1).restart();
      }

      this.onSimulationTick();
    }
  }, {
    key: "updatePositions",
    value: function updatePositions() {
      this.setState({
        nodes: this.simulation.nodes()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          theme = _this$props.theme,
          themes = _this$props.themes,
          width = _this$props.width,
          height = _this$props.height,
          edgeColors = _this$props.edgeColors,
          inverted = _this$props.inverted,
          tertiary = _this$props.tertiary,
          background = _this$props.background,
          hasCurvedEdges = _this$props.hasCurvedEdges,
          selfLinkAngle = _this$props.selfLinkAngle,
          showNodeTooltips = _this$props.showNodeTooltips,
          showEdgeTooltips = _this$props.showEdgeTooltips,
          showGroupNames = _this$props.showGroupNames,
          draggable = _this$props.draggable,
          onDragEnd = _this$props.onDragEnd,
          onEdgeClick = _this$props.onEdgeClick,
          onNodeClick = _this$props.onNodeClick,
          compatibilityMode = _this$props.compatibilityMode;
      var _this$state = this.state,
          nodes = _this$state.nodes,
          edges = _this$state.edges,
          hoveredNode = _this$state.hoveredNode,
          nodeRadiusScale = _this$state.nodeRadiusScale,
          linkWidthScale = _this$state.linkWidthScale,
          arrowWidthScale = _this$state.arrowWidthScale; // Render nodes

      var nodeFill = determineNodeFill(this.props);
      var nodeStroke = determineNodeStroke(this.props);
      var nodeElements = nodes.map(function (node) {
        // Render filled circle
        var isHighlighted = onNodeClick && hoveredNode && hoveredNode.id === node.id;
        var style = {
          cursor: draggable ? 'move' : onNodeClick ? 'pointer' : 'default',
          fill: nodeFill(node.id),
          stroke: nodeStroke(node.id),
          strokeWidth: '.5',
          opacity: isHighlighted ? '0.5' : '1'
        };

        var refCallback = function refCallback(elm) {
          return assignDragHandlers(elm, _this2.simulation, node, onDragEnd);
        };

        var ref = draggable ? refCallback : null;
        var radius = nodeRadiusScale(node.value);

        var onMouseOver = function onMouseOver(event) {
          _this2.setState({
            hoveredNode: _objectSpread(_objectSpread({}, node), {}, {
              target: event.target
            })
          });
        };

        var onMouseLeave = function onMouseLeave() {
          return _this2.setState({
            hoveredNode: null
          });
        };

        var circle = /*#__PURE__*/_react.default.createElement("circle", {
          key: node.id,
          ref: ref,
          style: style,
          r: radius,
          cx: node.x,
          cy: node.y,
          onMouseOver: onMouseOver,
          onMouseLeave: onMouseLeave,
          onClick: function onClick() {
            return _this2.handleNodeClick(node);
          }
        }); // render node names if enabled


        if (showGroupNames) {
          radius = Math.max(radius, 10);
          var isLeftHalf = node.x < width / 2;
          var isTopHalf = node.y < height / 2;

          var GroupNames = function GroupNames(props) {
            return /*#__PURE__*/_react.default.createElement("text", _extends({
              x: isLeftHalf ? node.x - radius : node.x + radius,
              y: isTopHalf ? node.y - radius : node.y + radius,
              textAnchor: isLeftHalf ? 'end' : 'start',
              alignmentBaseline: isTopHalf ? 'baseline' : 'hanging',
              fontFamily: "Raleway",
              fontWeight: "500",
              fontSize: "13px",
              fill: theme.inverted.two[2]
            }, props), node.name);
          };

          return /*#__PURE__*/_react.default.createElement("g", {
            key: node.id
          }, circle, /*#__PURE__*/_react.default.createElement(GroupNames, {
            stroke: theme.inverted.two[0],
            strokeWidth: "5px"
          }), /*#__PURE__*/_react.default.createElement(GroupNames, null));
        }

        return circle;
      });

      var hatchPattern = /*#__PURE__*/_react.default.createElement("pattern", {
        id: "diagonalNodeHatch",
        width: "4",
        height: "4",
        patternTransform: "rotate(135 0 0)",
        patternUnits: "userSpaceOnUse"
      }, /*#__PURE__*/_react.default.createElement("line", {
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "4",
        stroke: nodeStroke(),
        strokeWidth: "2",
        strokeOpacity: "0.5"
      })); // Render links (paths)


      var linkColor = determineLinkColor(edgeColors, tertiary, inverted, theme);
      var arrowElements = edges.map(function (e, i) {
        var startArrow, endArrow, line, lineHover;
        var isSelfLink = e.source.id === e.target.id;
        var rotation = isSelfLink ? "rotate(".concat(selfLinkAngle, ", ").concat(e.source.x, ", ").concat(e.source.y, ")") : null;
        var normalizedValue = linkWidthScale(e.value);
        var arrows = arrowHeads(e.source, e.target, e.value, arrowWidthScale, nodeRadiusScale);
        var fill = linkColor(e.themeId); // Arrows

        if (e.isUniDirectional && !isSelfLink) {
          startArrow = /*#__PURE__*/_react.default.createElement("path", {
            className: "arrow",
            transform: arrows.source.transform,
            d: arrows.source.d,
            fill: fill
          });
        }

        if (!isSelfLink) {
          endArrow = /*#__PURE__*/_react.default.createElement("path", {
            className: "arrow",
            transform: arrows.target.transform,
            d: arrows.target.d,
            fill: fill
          });
        } // Line


        line = /*#__PURE__*/_react.default.createElement("path", {
          key: i,
          className: "link",
          stroke: fill,
          colorRendering: "optimizeQuality",
          strokeWidth: normalizedValue,
          d: linkPath(e.source, e.target, nodeRadiusScale, hasCurvedEdges, normalizedValue, e.isUniDirectional),
          transform: rotation,
          fill: "none"
        }); // Hover line (transparent edge with high width, makes it easier to hover for tooltips on thin edges)

        if (showEdgeTooltips) {
          var onMouseOver = function onMouseOver(event) {
            _this2.setState({
              hoveredEdge: _objectSpread(_objectSpread({}, e), {}, {
                target: event.target
              })
            });
          };

          var onMouseLeave = function onMouseLeave() {
            return _this2.setState({
              hoveredEdge: null
            });
          };

          lineHover = /*#__PURE__*/_react.default.createElement("path", {
            key: i,
            stroke: "hotpink",
            strokeWidth: "14",
            strokeOpacity: "0",
            d: linkPath(e.source, e.target, nodeRadiusScale, hasCurvedEdges, normalizedValue, e.isUniDirectional),
            transform: rotation,
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            fill: "none"
          });
        }

        return /*#__PURE__*/_react.default.createElement(EdgeGroup, {
          key: i,
          onClick: function onClick() {
            return _this2.handleEdgeClick(e);
          },
          isClickable: onEdgeClick != null
        }, endArrow, startArrow, /*#__PURE__*/_react.default.createElement("g", null, line), /*#__PURE__*/_react.default.createElement("g", null, lineHover));
      }); // Render edge tooltips, if enabled

      var tooltip;

      if (showEdgeTooltips) {
        var hoveredEdge = this.state.hoveredEdge;

        if (hoveredEdge) {
          tooltip = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
            centered: true,
            target: hoveredEdge.target
          }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "GroupsNetworkGraph.edgeTooltip.header",
            defaultMessage: "{count} {count, plural, one {question} other {questions}}",
            values: {
              count: hoveredEdge.value
            }
          })), /*#__PURE__*/_react.default.createElement(_EdgeLegend.default, {
            inverted: true,
            colors: edgeColors,
            edge: hoveredEdge,
            themes: themes
          })));
        }
      } // Render node tooltip, if enabled


      if (showNodeTooltips) {
        var _hoveredNode = this.state.hoveredNode;

        if (_hoveredNode) {
          tooltip = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
            target: _hoveredNode.target
          }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, _hoveredNode.name)), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "GroupsNetworkGraph.nodeTooltip.content",
            defaultMessage: "received {count} {count, plural, one {question} other {questions}}",
            values: {
              count: _hoveredNode.value
            }
          }))));
        }
      }

      var bg;

      if (background) {
        var bgColor = inverted ? theme.inverted.two[0] : theme.two[0];
        bg = /*#__PURE__*/_react.default.createElement("rect", {
          width: "100%",
          height: "100%",
          fill: bgColor
        });
      } // Show spinner during simulation on IE11 (to avoid animation glitches)


      var isIE11 = compatibilityMode && !!window.MSInputMethodContext && !!document.documentMode;

      if (!isIE11 || this.state.simulationEnded) {
        var svg = /*#__PURE__*/_react.default.createElement("svg", {
          width: width,
          height: height
        }, bg, tertiary ? hatchPattern : null, /*#__PURE__*/_react.default.createElement("g", null, arrowElements), /*#__PURE__*/_react.default.createElement("g", null, nodeElements));

        if (tooltip) {
          return /*#__PURE__*/_react.default.createElement("div", null, svg, tooltip);
        }

        return svg;
      } else {
        return /*#__PURE__*/_react.default.createElement("div", null, "Loading network visualization");
      }
    }
  }]);

  return GroupsNetworkGraph;
}(_react.Component);

GroupsNetworkGraph.createSimulation = createSimulation;
GroupsNetworkGraph.propTypes = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  linkForceDistance: _propTypes.default.number,
  nodeCollideRadius: _propTypes.default.number,
  selfLinkAngle: _propTypes.default.number,
  size: _propTypes.default.oneOf(['regular', 'small']),
  showNodeTooltips: _propTypes.default.bool,
  showEdgeTooltips: _propTypes.default.bool,
  showGroupNames: _propTypes.default.bool,
  draggable: _propTypes.default.bool,
  inverted: _propTypes.default.bool,
  secondary: _propTypes.default.bool,
  tertiary: _propTypes.default.bool,
  background: _propTypes.default.bool,
  onDragEnd: _propTypes.default.func,
  onSimulationEnd: _propTypes.default.func,
  edgeColors: _propTypes.default.func,
  onEdgeClick: _propTypes.default.func,
  nodeCoordinates: _propTypes.default.object,
  // Map of coordinates by id (id -> { x, y })
  compatibilityMode: _propTypes.default.bool
};
GroupsNetworkGraph.defaultProps = {
  width: 600,
  height: 600,
  linkForceDistance: -150,
  nodeCollideRadius: 60,
  selfLinkAngle: 55,
  size: 'regular',
  showNodeTooltips: true,
  showEdgeTooltips: false,
  showGroupNames: false,
  draggable: false,
  inverted: false,
  secondary: false,
  tertiary: false,
  background: false,
  onDragEnd: function onDragEnd() {},
  onSimulationEnd: function onSimulationEnd() {},
  nodeCoordinates: null,
  compatibilityMode: true // Do extra checks for IE support

};

var _default = (0, _styledComponents.withTheme)(GroupsNetworkGraph);

exports.default = _default;
//# sourceMappingURL=GroupsNetworkGraph.js.map